<template>
  <section>
    <div v-for="(img, index) in images" :key="index">
      <PrintCanvas id="print-area" :class="paper"
        :sourceImage="img.image" :zoom="img.zoom"
        :centerx="img.centerx" :centery="img.centery"
        v-if="useCanvas"/>
      <BrowseImage :imageUrl="img" :paper="paper" :descText="descText"
        v-else/>
    </div>
  </section>
</template>

<script>
import BrowseImage from '../components/BrowseImage.vue'
import PrintCanvas from '../views/PrintCanvas.vue';
export default {
  components: {
    BrowseImage,
    PrintCanvas,
  },
  props: {
    useCanvas: {
      type: Boolean,
      default: false,
    },
    images: {
      type: Array,
      default: null,
    },
    paper: {
      type: String,
      default: 'A4',
    },
    descText: {
      type: Array,
      default: null,
    },
  },
  computed: {
  },
  mounted () {
    //console.log(`PrintImage: images=${this.images.length}`);
    this.$store.commit('setPrinting', true);
    //ToDo: 画像のロード待ちが必要か
    //ToDo: 用紙サイズの調整
    setTimeout(() => {
      window.print();
      this.$store.commit('setPrinting', false);
      this.$router.back();
    }, 1000);
  },
}
</script>
<style lang="scss" scoped>
.A4 {
  height: calc(296mm - 22mm);
  //width: calc(210mm - 16mm);
  width: auto;
  page-break-after: auto;
  background-color: white;
}
@media print {
  @page {
    size: A4;
    //size: A4 portrait !important;
    //size: auto !important;
    margin: 0;
    background: none !important;
  }
  body {
    margin: 0mm;
    padding: 0mm;
    background: none !important;
  }
  main {
    margin: 0mm;
    padding: 0mm;
    background: none !important;
  }
  .A4 {
    height: calc(296mm - 26mm) !important;
    //width: calc(210mm - 24mm);
    //width: auto;
  }
}
</style>
